<template>
  <!-- :list="state.list"  :loading="state.loading"-->
  <basic-list
    :showIndexCol="false"
    :show-select-col="true"
    :show-action-col="false"
    :table-h="tableH"
    :fields="fields"
    select-type="singleMult"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    :page-index="state.pageIndex"
    :page-size="state.pageSize"
    :page-index-change="pageIndexChange"
    :page-size-change="pageSizeChange"
    :selection-change="selectionChange"
    highlight-current
  >
    <template slot="hd-col--l">
      <el-button type="primary" size="mini" @click="handleAdd">{{$t('language.5o6uyb93urg0')}}</el-button>
      <el-button size="mini" @click="onEdit">{{$t('language.5o6u3frcno50')}}</el-button>
      <!-- <el-button  size="mini" @click="onStop">停用</el-button> -->
      <!-- <el-button size="mini" @click="onWorkflow">配置审批流</el-button> -->
    </template>
  </basic-list>
</template>

<script>
import ExactList from "@/mixins/exactList";
export default {
  mixins: [ExactList],

  data() {
    return {
      fields: [
        { key: "appName", name: `${this.$t('language.5o6vnf9rx200')}`},
        { key: "appCode", name: `${this.$t('language.5o6u3wttipk0')}`},
        { key: "domainName", name: `${this.$t('language.5o6w90h4lws0')}`},
        { key: "createTime", name: `${this.$t('language.5o6otz4p1t00')}`},
        { key: "appSource", name: `${this.$t('language.5o6otz4p1ps0')}`},
        { key: "remark", name: `${this.$t('language.5o6otz4p1w00')}`},
        { key: "flowId", name: `${this.$t('language.5o6w90h4mao0')}`},
        { key: "principal", name: `${this.$t('language.5o6w90h4me80')}`},
        { key: "principalErpCode", name: `${this.$t('language.5o6w90h4mhc0')}`},
      ],
    };
  },
  methods: {
    onEdit() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(`${this.$t('language.5o6v4bolgjc0')}`);
        return;
      }
      if (rows.length > 1) {
        this.$message.error(`${this.$t('language.5o6v4bolglk0')}`);
        return;
      }
      this.handleEdit({ id: rows[0].id }, true);
      //  this.handleEdit(rows[0])
    },
    onStop() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(`${this.$t('language.5o6v4bolgjc0')}`);
        return;
      }
      if (rows.length > 1) {
        this.$message.error(`${this.$t('language.5o6v4bolglk0')}`);
        return;
      }
      this.handleDelete(rows[0]);
    },
    onWorkflow() {
      const rows = this.selRows;
      if (!rows.length) {
        this.$message.error(`${this.$t('language.5o6w90h4mr80')}`);
        return;
      }
      if (rows.length > 1) {
        this.$message.error(`${this.$t('language.5o6w90h4n700')}`);
        return;
      }
      this.handleWorkflow({ id: rows[0].id });
    },
  },
};
</script>
